/* eslint-disable no-param-reassign */
import axios from 'axios';
// import Vue from 'vue';
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import uniq from 'lodash/uniq';
import cacheAxios from '../../util/cacheAxios';

const jobAxios = axios.create();
const cache = new Map();
cacheAxios(jobAxios, cache);
jobAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });
const legendRef = {
  bottom: '10%',
  right: '1%',
  orient: 'vertical',
  align: 'right',
};

export default {
  state: {
    jobTrends: [],
    jobCountries: [],
    jobDemandMatrix: {},
    jobSupplyMatrix: [],
    hrIndicators: [],
    hrIndicatorHistory: {},
    lvlFuncChartOptions: {
      title: {
        left: 'center',
        top: '1%',
        text: 'Change in ',
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      grid: {
        left: '3%',
        right: '12%',
        bottom: '25px',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      clear: true,
      series: [{
        type: 'line',
      }],
      xAxis: {
        type: 'category',
        data: [],
        splitLine: {
          show: false,
        },
        axisPointer: {
          type: 'shadow',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
      },
      legend: {
        bottom: '10%',
        right: '1%',
        orient: 'vertical',
        align: 'right',
      },
    },
    lvlFuncChartLoading: false,
    jobTotalChartLoading: false,
    jobTotalChartOptions: {
      title: {
        left: 'center',
        top: '1%',
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '25px',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: {
        type: 'line',
      },
      xAxis: {
        type: 'category',
        data: [],
        splitLine: {
          show: false,
        },
        axisPointer: {
          type: 'shadow',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
      },
    },
    chartLoading: false,
    chartOptions: {
      title: {
        left: 'center',
        top: '1%',
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      grid: {
        left: '3%',
        right: '12%',
        bottom: '35px',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: [],
      xAxis: {
        type: 'category',
        data: [],
        splitLine: {
          show: false,
        },
        axisPointer: {
          type: 'shadow',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
      },
    },
  },
  mutations: {
    setJobTrends(state, trends) {
      state.jobTrends = sortBy(trends, 'endDate');
    },
    addHrIndicatorHistory(state, indicators) {
      const g = groupBy(indicators, ind => `${ind.indicator}|${ind.countryCode}`);
      state.hrIndicatorHistory = {
        ...state.hrIndicatorHistory,
        ...g,
      };
    },
    setHrIndicators(state, indicators) {
      state.hrIndicators = indicators;
    },
    setJobSupplyMatrix(state, matrix) {
      state.jobSupplyMatrix = matrix;
    },
    setJobCountries(state, countries) {
      state.jobCountries = countries;
    },
    setJobDemandMatrix(state, matrix) {
      const final = {};
      Object.keys(matrix)
        .forEach((k) => {
          final[k] = matrix[k].toFixed(3);
        });

      // arr = sortBy(arr, i => i.value);
      // let nonZero = arr.filter(i => i.value !== 0);
      // const zero = arr.filter(i => i.value === 0);
      // nonZero = nonZero.map((item, i) => ({
      //   key: item.key,
      //   value: (i + 1) / nonZero.length,
      // }));
      // const final = {};
      // zero.forEach((i) => {
      //   final[i.key] = i.value.toFixed(3);
      // });
      // nonZero.forEach((i) => {
      //   final[i.key] = i.value.toFixed(3);
      // });
      state.jobDemandMatrix = final;
    },
    setChartLoading(state, loading) {
      state.chartLoading = loading;
    },
    plotLvlFunctionChart(state, {
      selections,
      lvlOrFn,
    }) {
      const title = {
        ...state.lvlFuncChartOptions.title,
        text: 'No. of Jobs',
      };
      const xData = [];
      const series = [];
      const legend = {
        ...state.lvlFuncChartOptions.legend,
        data: [],
      };
      if (selections.length > 0 && lvlOrFn !== '') {
        const selectionsDataMap = {};
        for (let i = 0; i < state.jobTrends.length; i++) { // eslint-disable-line no-plusplus
          const jt = state.jobTrends[i];
          const key =
            `${jt.endDate.substr(0, 4)}-${jt.endDate.substr(4, 2)}-${jt.endDate.substr(6, 2)}`;
          xData.push(key);
          selections.forEach((s) => {
            const val = jt[lvlOrFn][s] ? jt[lvlOrFn][s].toFixed(1) : 0;
            if (!(s in selectionsDataMap)) {
              selectionsDataMap[s] = [val];
            } else {
              selectionsDataMap[s].push(val);
            }
          });
        }
        selections.forEach((s) => {
          series.push({
            name: s,
            type: 'line',
            data: selectionsDataMap[s],
          });
          legend.data.push(s);
        });
      }
      const xAxis = {
        ...state.lvlFuncChartOptions.xAxis,
        data: xData,
      };
      // const series = {
      //   ...state.lvlFuncChartOptions.series,
      //   data: seriesData,
      // };
      state.lvlFuncChartOptions = {
        ...state.lvlFuncChartOptions,
        title,
        xAxis,
        series,
        legend,
      };
    },
    plotJobTotalNoChart(state, {
      query,
      countryInfos,
      sectorMap,
    }) {
      let prepend = query.countryFilter ? countryInfos[query.countryFilter] : '';
      const postpend = query.sectorFilter ? sectorMap[query.sectorFilter] : '';
      if (prepend && postpend) {
        prepend = prepend.concat(' / ');
      }
      const title = {
        ...state.jobTotalChartOptions.title,
        text: 'Total No. of Jobs',
        subtext: `${prepend}${postpend}`,
      };
      const xData = [];
      const seriesData = [];
      state.jobTrends.forEach((jt) => {
        const key =
          `${jt.endDate.substr(0, 4)}-${jt.endDate.substr(4, 2)}-${jt.endDate.substr(6, 2)}`;
        xData.push(key);
        seriesData.push(jt.totalCount);
      });
      const xAxis = {
        ...state.jobTotalChartOptions.xAxis,
        data: xData,
      };
      const series = {
        ...state.jobTotalChartOptions.series,
        data: seriesData,
      };
      state.jobTotalChartOptions = {
        ...state.jobTotalChartOptions,
        title,
        xAxis,
        series,
      };
    },
    plotHrIndicator(state, {
      query,
      countryInfos,
    }) {
      const title = {
        ...state.chartOptions.title,
        text: query.i,
        top: '1%',
        left: 'center',
      };
      const countries = query.c.filter(c => state.hrIndicatorHistory[`${query.i}|${c}`]);
      const legend = {
        ...legendRef,
        data: countries.map(code => countryInfos[code]),
      };
      const xAxisData = [];
      // let yMin = 1;
      const chartsToPlot = countries.map((c) => {
        const data = state.hrIndicatorHistory[`${query.i}|${c}`].map(o => ([o.year, o.value]));
        return {
          data,
          label: {
            normal: {
              show: false,
              formatter: '{a}',
            },
            emphasis: {
              show: true,
              formatter: '{a}',
            },
          },
          name: countryInfos[c],
          type: 'line',
        };
      });
      // countries.forEach((c) => {
      //   state.hrIndicatorHistory[`${query.i}|${c}`].forEach((o) => {
      //     yMin = yMin > o.value ? o.value : yMin;
      //   });
      // });
      // yMin = Math.floor(yMin * 20) / 20;
      chartsToPlot.forEach((c) => {
        c.data.forEach(d => (xAxisData.push(d[0])));
      });
      const xAxis = {
        ...state.chartOptions.xAxis,
        data: uniq(xAxisData)
          .sort(),
      };
      // const yAxis = {
      //   ...state.chartOptions.yAxis,
      //   min: yMin,
      // };

      state.chartOptions = {
        ...state.chartOptions,
        title,
        xAxis,
        // yAxis,
        legend,
        series: chartsToPlot,
        clear: true,
      };
      state.chartLoading = false;
    },
  },
  actions: {
    getJobTrends({
      commit,
      getters,
    }, query) {
      if (!query.countryFilter && !query.sectorFilter) {
        commit('setJobTrends', []);
        commit('plotJobTotalNoChart', {
          query,
          countryInfos: getters.countryInfos,
          sectorMap: getters.sectorMap,
        });
        return Promise.resolve();
      }
      return jobAxios.post('/aims/api/job/trends', query)
        .then((res) => {
          if (res.data) {
            commit('setJobTrends', res.data);
          } else {
            commit('setJobTrends', []);
          }
          commit('plotJobTotalNoChart', {
            query,
            countryInfos: getters.countryInfos,
            sectorMap: getters.sectorMap,
          });
        });
    },
    getHrIndicatorHistory({
      commit,
      state,
      getters,
    }, query) {
      commit('setChartLoading', true);
      const filteredQuery = {
        ...query,
        c: query.c.filter(c => !state.hrIndicatorHistory[`${query.i}|${c}`]),
      };
      if (filteredQuery.c.length > 0) {
        jobAxios.post('/aims/api/job/hrIndicatorHistory', filteredQuery)
          .then((res) => {
            if (res.data) {
              const g = sortBy(res.data.map(i => ({
                countryCode: i.c,
                group: i.g,
                indicator: i.i,
                value: i.v,
                year: i.y,
              })), 'year');
              commit('addHrIndicatorHistory', g);
            }
          })
          .then(() => {
            commit('plotHrIndicator', {
              query,
              countryInfos: getters.countryInfos,
            });
          });
      } else {
        commit('plotHrIndicator', {
          query,
          countryInfos: getters.countryInfos,
        });
      }
    },
    getHrIndicators({
      commit,
    }) {
      jobAxios.get('/aims/api/job/hrIndicators')
        .then((res) => {
          if (res.data) {
            const indicators = res.data.map(a => ({
              description: a.desc,
              group: a.grp,
              high: a.hi,
              low: a.lo,
              indicator: a.ind,
            }));
            commit('setHrIndicators', indicators);
          }
        });
    },
    getJobDemandMatrix({
      commit,
    }) {
      jobAxios.get('/aims/api/job/jobDemandMatrix')
        .then((res) => {
          if (res.data) {
            commit('setJobDemandMatrix', res.data);
          }
        });
    },
    getJobSupplyMatrix({
      commit,
    }) {
      jobAxios.get('/aims/api/job/jobSupplyMatrix')
        .then((res) => {
          if (res.data) {
            const indexes = res.data.map(a => ({
              countryName: a.cty,
              countryCode: a.ctyC,
              continent: a.ctn,
              region: a.reg,
              globalCompetitivenessIndex: a.gci,
              hrCompetitivenessIndex: a.hci,
              educationIndex: a.ei,
              innovation: a.inn,
              labourMarketEfficiency: a.lme,
            }));
            commit('setJobSupplyMatrix', indexes);
          }
        });
    },
    initJobCountries({
      commit,
    }) {
      jobAxios.get('/aims/api/job/countries')
        .then((res) => {
          if (res.data) {
            commit('setJobCountries', res.data);
          }
        });
    },
    filterJobCompanies({
      commit,
    }, jobFilter) {
      return jobAxios.post('/aims/api/job/companiesFilter', jobFilter)
        .then((res) => {
          if (res.data) {
            commit('setFilteredJobCompanies', res.data);
          } else {
            commit('setFilteredJobCompanies', []);
          }
        });
    },
  },
  getters: {
    countryInfos(state, getters, rootState) {
      const countryInfoMap = {};
      rootState.econPredictor.regionsGroup
        .forEach((region) => {
          region.countryInfos.forEach((ci) => {
            countryInfoMap[ci.countryCode] = ci.countryName;
          });
        });
      return countryInfoMap;
    },
    sectorMap(state, getters, rootState) {
      const sectors = {};
      rootState.finance.sectors
        .forEach((sector) => {
          sectors[sector.code] = sector.name;
        });
      return sectors;
    },
    // continents(state) {
    //   return Object.keys(groupBy(state.countryInfos, 'continent'));
    // },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/jobModule.js